const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// GET
		case "SHIPPING_PAYMENT_OPTIONS_LOADING":
			return {
				...initialState,
				isLoading: true
			};

		case "SHIPPING_PAYMENT_OPTIONS_ERROR":
			return {
				...state,
				isLoading: false,
				error: action.err
			};

		case "SHIPPING_PAYMENT_OPTIONS_SUCCESS":
			return {
				...state,
				isLoading: false,
				options: action.data.options
			};

		// SET
		case "SHIPPING_PAYMENT_SELECTION_LOADING":
			return {
				...state,
				selectionError: null,
				selectionLoading: true
			};

		case "SHIPPING_PAYMENT_SELECTION_ERROR":
			return {
				...state,
				selectionLoading: false,
				selectionError: action.err
			};

		case "SHIPPING_PAYMENT_SELECTION_SUCCESS":
			return {
				...state,
				selectionLoading: false
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/shippingPayment.js